import { MediaConfigWithSide } from 'features/CaseStudy/types';
import styles from './TextWithMedia.module.css';
import { Media } from '../ui/Media';
import { clsx } from 'clsx';

type TextWithMediaProps = {
  paragraphs: string[];
  media: MediaConfigWithSide;
};

export const TextWithMedia = ({ paragraphs, media }: TextWithMediaProps) => {
  return (
    <div
      className={clsx(styles.sectionMainLayout, {
        [styles.sectionMainLayoutMediaLeft]: media.side === 'left',
      })}>
      <div className={styles.textSubsection}>
        {paragraphs.map((paragraph, index) => (
          <p className={styles.paragraph} key={index}>
            {paragraph}
          </p>
        ))}
      </div>
      <div className={styles.mediaSubsection}>
        <Media mediaConfig={media} />
      </div>
    </div>
  );
};
